import React from 'react'

import { Root } from './PeopleChart.styled.js'

const peopleArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
const personPath =
  'M13.263 51.328a1.665 1.665 0 01-1.655-1.656v-20.8l-4.309 3.584 2.358 5.919a3.128 3.128 0 01.3 1.361 3.3 3.3 0 01-3.311 3.311 3.334 3.334 0 01-3.085-2.086L.25 32.683a3.267 3.267 0 01.953-3.765l9.933-8.279a3.27 3.27 0 012.11-.771h16.557a3.269 3.269 0 012.109.771l9.934 8.279a3.419 3.419 0 011 3.765l-3.311 8.278a3.323 3.323 0 01-3.085 2.086 3.484 3.484 0 01-1.361-.294 3.307 3.307 0 01-1.678-4.378l2.382-5.919-4.31-3.584v20.8a1.665 1.665 0 01-1.655 1.656zM13.241 8.28A8.267 8.267 0 0121.519.001a8.281 8.281 0 018.279 8.279 8.267 8.267 0 01-8.279 8.278A8.281 8.281 0 0113.24 8.28z'

const personWidth = 43
const personHeight = 52
const space = 7
const offset = personWidth + space
const svgWidth = offset * 10 - space

const PeopleChart = ({ pct, uid }) => {
  return (
    <Root>
      <svg viewBox={`0 0 ${svgWidth} ${personHeight}`}>
        <defs>
          <path id="person" d={personPath}></path>
          <linearGradient id={`gradient_${uid}`}>
            <stop offset="0%" stopColor="#5255a5" />
            <stop offset="100%" stopColor="#3395bb" />
          </linearGradient>
          <mask id={`mask_${uid}`}>
            {peopleArray.map(id => (
              <use
                key={id}
                href="#person"
                fill="#ffffff"
                transform={`translate(${id * offset}, 0)`}
              ></use>
            ))}
          </mask>
        </defs>
        <g mask={`url(#mask_${uid})`}>
          <rect width={svgWidth} height={personHeight} fill="rgba(48, 99, 152, 0.2)"></rect>
          <rect width={svgWidth * pct} height={personHeight} fill={`url(#gradient_${uid})`}></rect>
        </g>
      </svg>
    </Root>
  )
}

export default PeopleChart
